import React, { useState, useEffect } from 'react';
import { bool, string, number, func } from 'prop-types';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import '@laramie/ui/dist/components/common/InputLista/index.css';
import { useLista } from '../../hooks/useLista';
import ListasModal from '../../controls/ListasModal';
import Select from '../Select';

const InputLista = (props) => {

    const [state, setState] = useState({
        value: null,
        showList: false
    });

    useEffect(() => {
        setState(prevState => {
            return {...prevState, value: props.value };
        });
    }, [props.value]);

    const [getListLista, getRowLista, listaReady] = useLista({
        listas: [props.lista],
        onLoaded: (listas, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
          key: props.lista,
          timeout: 0
        }
    });

    const filteredItems = listaReady ? getListLista(props.lista).filter(props.filter) : [];

    useEffect(() => {
        if (props.autoSelect && !props.disabled && props.onChange
            && filteredItems.length === 1 && (!props.value || props.value === 0)) {
            props.onChange({
                target: {
                    name: props.name,
                    type: 'lista',
                    value: filteredItems[0].id,
                    row: filteredItems[0]
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredItems.length, filteredItems[0]?.id, props.value, props.disabled, props.autoSelect]);

    const onSelected = (id, row) => {
        if (props.onChange) {
            props.onChange({
                target: {
                    name: props.name,
                    type: 'lista',
                    value: id,
                    row: row
                }
            });
        }
        setState(prevState => {
            return {...prevState, showList: false};
        });
    }

    const format = (row) => (!row) ? '' : (props.showCode && row.codigo) ? `${row.codigo} - ${row.nombre}` : row.nombre;

    return (
        <div className='wrapper'>

            {props.showGrid && state.showList && (
                <ListasModal
                    title={props.title}
                    lista={props.lista}
                    tipName={props.tipName}
                    onDismiss={() => {
                        setState(prevState => {
                            return {...prevState, showList: false};
                        });
                    }}
                    filter={props.filter}
                    onConfirm={onSelected}
                    showCode={props.showCode}
                />
            )}

            {(props.showGrid) ?
                <input
                    name={props.name}
                    type="text"
                    placeholder={props.placeholder}
                    className={`input-lista ${props.className}`}
                    value={format(getRowLista(props.lista, state.value))}
                    onClick={() => {
                        setState(prevState => {
                            return {...prevState, showList: true};
                        });
                    }}
                    onKeyDown={(e) => { if (e.key === 'Enter') setState(prevState => ({...prevState, showList: true})); }}
                    readOnly={true}
                    disabled={props.disabled}
                />
            :
                <Select
                    name={props.name}
                    placeholder={props.textItemZero}
                    className={`input-lista ${props.className}`}
                    value={state.value??0}
                    onChange={props.onChange}
                    rows={filteredItems}
                    onFormat={format}
                    disabled={props.disabled}
                    emptyOption={props.withItemZero ? (props.textItemZero || 'Sin selección') : undefined}
                    emptyValue={0}
                />
            }

            {props.showGrid && !props.disabled && <span
                className="material-symbols-outlined icon-cruz"
                onClick={() => onSelected(0, null)}
            >close</span>}
        </div>
    )
}

InputLista.propTypes = {
    title: string,
    lista: string.isRequired,
    name: string.isRequired,
    placeholder: string,
    textItemZero: string,
    className: string,
    value: number,
    onChange: func,
    filter: func,
    showCode: bool,
    showGrid: bool,
    disabled: bool,
    withItemZero: bool,
    autoSelect: bool,
    tipName: string
};

InputLista.defaultProps = {
    title: "",
    placeholder: "",
    textItemZero: "",
    className: "",
    value: null,
    onChange: null,
    filter: (row) => { return true },
    showCode: false,
    showGrid: false,
    disabled: false,
    withItemZero: true,
    autoSelect: true,
    tipName: ''
};

export default InputLista;
